
import { URLS } from '../constants'
import {
    GET_COMPANY_BEGIN, GET_COMPANY_SUCCESS, GET_COMPANY_FAILURE,
    CLEAN_COMPANY
} from '../constants/ActionTypes'

import { dispatchFetchGet } from './ActionUtil'

// Get Company
const acGetCompanyBegin = () => ({ type: GET_COMPANY_BEGIN })
const acGetCompanySuccess = data => ({ type: GET_COMPANY_SUCCESS, payload: data })
const acGetCompanyFailure = err => ({ type: GET_COMPANY_FAILURE, payload: err })

/**
 * @description Dispatches a GET request to retrieve a company.
 *
 * @author Maria Eduarda Franke
 */
export const acGetCompany = cnpj => {
    return dispatchFetchGet(
        `${URLS.COMPANY}/cnpj/${cnpj}`,
        acGetCompanyBegin,
        acGetCompanySuccess,
        acGetCompanyFailure
    )
}

// Clean Company
export const acCleanCompany = () => ({ type: CLEAN_COMPANY })